import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b70f0e62&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b70f0e62')) {
      api.createRecord('b70f0e62', component.options)
    } else {
      api.reload('b70f0e62', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b70f0e62&", function () {
      api.rerender('b70f0e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lZhoWBVGNBXa/JS/pricehelp.vue"
export default component.exports